function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var expires = '';

    if (exdays != -1) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = 'expires=' + d.toUTCString();
    }

    document.cookie = cname + '=' + cvalue + '; ' + expires + cookieFlags();
}

function deleteCookie(cname) {
    document.cookie = cname +'=; Max-Age=-99999999' + cookieFlags();
}

// Secure only over https so the plain-http lab setup keeps working.
function cookieFlags() {
    return '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
}

function numOfOccurences(st, subst) {
    if (st === "") {
        return 0;
    }

    var arr = st.split(subst);

    return arr.length;
}

module.exports = {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
    numOfOccurences: numOfOccurences
};